import { overlayContentStyles, overlayStyles, urlUnderlineStyles } from './shortened-url-highlight-overlay.styles';

type ShortenedUrlHighlightOverlayProps = {
  /** Full current textarea value */
  text: string;
  /** The exact URL string that was detected */
  offendingUrl: string;
  /** Start index of the offending URL within `text` */
  offendingUrlIndex: number;
  /** Current textarea scroll offset so overlay text stays aligned */
  scrollTop?: number;
  /** Optional base styles to apply to the overlay content */
  overlayBaseStyles?: React.CSSProperties;
};

export const ShortenedUrlHighlightOverlay = ({
  text,
  offendingUrl,
  offendingUrlIndex,
  scrollTop = 0,
  overlayBaseStyles,
}: ShortenedUrlHighlightOverlayProps) => {
  const before = text.slice(0, offendingUrlIndex);
  const urlText = text.slice(offendingUrlIndex, offendingUrlIndex + offendingUrl.length);
  const after = text.slice(offendingUrlIndex + offendingUrl.length);

  return (
    <div
      className={overlayStyles}
      style={overlayBaseStyles}
      aria-hidden='true'
      data-testid='shortened-url-highlight-overlay'
    >
      <div className={overlayContentStyles} style={{ transform: `translateY(-${scrollTop}px)` }}>
        {before}
        <span className={urlUnderlineStyles}>{urlText}</span>
        {after}
      </div>
    </div>
  );
};
